import PracQuizBox from './PracQuizBox';

export default PracQuizBox;
